import {adminOrganizationsQueries} from '@app/admin/organizations/admin-organizations-queries';
import {authGuard} from '@common/auth/guards/auth-route';
import {shouldRevalidateDatatableLoader} from '@common/datatable/filters/utils/should-revalidate-datatable-loader';
import {queryClient} from '@common/http/query-client';
import {searchParamsFromUrl} from '@ui/utils/urls/search-params-from-url';
import {RouteObject} from 'react-router';

export const adminOrganizationsRoutes: Record<string, RouteObject> = {
  index: {
    path: 'organizations',
    lazy: () => import('@app/admin/organizations/organizations-datatable'),
    shouldRevalidate: shouldRevalidateDatatableLoader,
    loader: async ({request}) => {
      // matches the backend guard on OrganizationsController
      const redirect = authGuard({permission: 'organizations.view'});
      if (redirect) return redirect;
      return queryClient.ensureQueryData(
        adminOrganizationsQueries.index(searchParamsFromUrl(request.url)),
      );
    },
  },
  report: {
    // the printable Customer details page. Spread into the admin routes
    // outside the /admin/reports gate on purpose: dealers hold no
    // reports.view, but this is their customer too. A 404 from the server
    // (no such customer, or another dealer's) is thrown out of the loader
    // and lands on the router's error element as the not-found page, the
    // same way the edit-user page handles a bad id.
    path: 'organizations/:organizationId/report',
    lazy: () => import('@app/admin/organizations/organization-report-page'),
    loader: async ({params}) => {
      const redirect = authGuard({permission: 'organizations.view'});
      if (redirect) return redirect;
      return queryClient.ensureQueryData(
        adminOrganizationsQueries.report(params.organizationId!),
      );
    },
  },
};
